import { instanceAuth } from "api/apiConfig"

export const paymentFetchAPI = async data => {
  try {
    const response = await instanceAuth.get(
      "Finance/GetAllScholarshipPayments",
      {
        params: {
          ...data,
        },
      },
    )
    return response
  } catch (error) {
    console.log("error fetching payment data...", error)
    throw error
  }
}

export const paymentCreateAPI = async data => {
  try {
    const response = await instanceAuth.post(
      "Finance/RegisterNewScholarshipPayment",
      data,
    )
    return response
  } catch (error) {
    console.log("error creating payment...", error)
    throw error
  }
}

export const paymentUpdateAPI = async ({ id: id, data: data }) => {
  try {
    const response = await instanceAuth.put(
      `Finance/UpdateScholarshipPaymentById/${id}`,
      data,
    )
    return response
  } catch (error) {
    console.log("error updating payment...", error)
    throw error
  }
}

export const paymentDeleteAPI = async id => {
  try {
    const response = await instanceAuth.delete(
      `Finance/DeleteScholarshipPaymentById/${id}`,
    )
    return response
  } catch (error) {
    console.log("error deleting payment...", error)
    throw error
  }
}
